import theme from '../theme/theme';
import { Box, useMediaQuery } from "@mui/material";
import { BottomNav, Header, LeagueManager, RankedList } from '../components';

function Ranking() {

  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  const styles = {
    rankingBox: {
      width: isMdUp ? '700px' : isSmUp ? '80%' : '95%', 
    }
  }

  return (
    <div style={{height: '100vh'}}>

      <Header page={"Ranking"} />
      <BottomNav page={"Ranking"} />

      <Box component="main" 
      sx={{ flexGrow: 1, mt: isMdUp ? 8 : 0, p: isSmUp ? 5 : 3, pb: 5, minHeight: '100vh', backgroundColor: theme.palette.grey[200]}}>

        <Box 
          sx={{ 
            my: isMdUp ? 0 : 5, 
            //pt: isMdUp ? 5 : 0,
            pb: 5,
            mx: 'auto'
          }} 
          style={styles.rankingBox}
        >
          <RankedList isRankingScreen={true} />

          <LeagueManager />
        </Box>

      </Box>

    </div>
  );
}

export default Ranking;